<template>

  <el-main>

    <el-alert
      title="关于我（没有们）"
      type="success"
      effect="dark"
      :closable="false"
      description="90后油腻大叔，目前在北京，本站由本人独立完成，如若您能提供任何帮助，我都不胜感激，如若本站帮到了您且方便的话请帮忙推荐给身边的朋友。">
    </el-alert>
    <br>

    <el-alert
      title="联系方式"
      type="success"
      effect="dark"
      :closable="false"
      description="问题反馈请加QQ群: 914798904 联系我请加QQ（请说明来自网址导航）: 710032676">
    </el-alert>
    <br>

    <div style="text-align: center">

      <el-image
        style="width: 200px; height: 350px;"
        :alt="'QQ群联系我'"
        :src="require('@/assets/qqs.jpeg')"></el-image>

      <el-image
        style="width: 200px; height: 350px; margin-left: 100px"
        :alt="'QQ联系我'"
        :src="require('@/assets/qq.jpeg')"></el-image>

    </div>

  </el-main>

</template>

<script>
export default {
  name: 'About',
  data () {
    return {

    }
  },
  created: function () {
    document.title = '网湖 - 关于我们 - 网址导航|网站导航|网址大全|网站大全'
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  margin-left: 10%;
  width: 80%;
  min-height: 85vh;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue